import { memo } from "react";
import type { CSSProperties, FC } from "react";

import SnailSVG from "images/icons/snail.svg?url";
import StrawberrySVG from "images/icons/strawberry.svg?url";
import WaterDropSVG from "images/icons/waterDrop.svg?url";

const getBackgroundImageStyles = (status: string | null) => {
  if (status === null) return undefined;

  const styles: CSSProperties = {
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
  };

  if (status === "strawberry") {
    styles.color = "#FFF";
    styles.backgroundImage = `url(${StrawberrySVG})`;
    styles.backgroundPosition = "55% 25%";
  } else if (status === "slime") {
    styles.color = "#FFF";
    styles.backgroundImage = `url(${SnailSVG})`;
    styles.backgroundPosition = "55% 25%";
  } else if (status === "elixir_of_life") {
    styles.color = "#FFF";
    styles.backgroundImage = `url(${WaterDropSVG})`;
    styles.backgroundPosition = "55% 25%";
  }

  return styles;
};

// AIDEV-NOTE: Jen primitivní props a žádné hooky. react-calendar předává při každém renderu nový objekt
// `Date`, takže `memo` by s ním nikdy neuspělo; CalendarMonth proto dosadí číslo dne a předpočítané texty
// (štítek, minuty), ať se při obnově dat na pozadí překreslí jen dny, které se opravdu změnily. Stejně
// tak tu není useTranslation ani useAppSelector: bylo jich ~270 na stránku. [TD-476]
interface Props {
  dayOfMonth: number;
  isToday: boolean;
  isDeadline: boolean;
  withTest: boolean;
  /** Text štítku nad číslem dne (termín přijímaček/maturity, jinak test); `null` = bez štítku. */
  labelText: string | null;
  showPlannedDot: boolean;
  /** Naplánované minuty včetně jednotky; `null` = den bez tréninku. */
  durationText: string | null;
  status: string | null;
}

const CalendarDay: FC<Props> = ({
  dayOfMonth,
  isToday,
  isDeadline,
  withTest,
  labelText,
  showPlannedDot,
  durationText,
  status,
}) => (
  <div
    className={`react-calendar__month-view__days__day__inner ${isToday ? "today" : ""}`}
    style={getBackgroundImageStyles(status)}
  >
    {labelText !== null ? (
      <div className={`label ${isDeadline ? "label-pink" : "label-purple"}`}>{labelText}</div>
    ) : null}
    <strong className={isDeadline ? "text-pink" : withTest ? "text-purple" : ""}>{dayOfMonth}</strong>
    {showPlannedDot ? <div className={`status-dot mx-auto d-print-none gray`} /> : null}
    {durationText !== null && <time className={isToday ? "text-white" : "text-muted"}>{durationText}</time>}
  </div>
);

export default memo(CalendarDay);
